import "./NewsHeadlineComponent.scss";
import template from "./NewsHeadlineComponent.html";
import {IComponentOptions, IRootElementService} from "angular";
import {isDocumentModel, isHtmlModel, isTextModel, NewsHeadlineViewModel} from "../../../models/NewsHeadlineViewModel";
import {NewsFeedComponentController} from "../news-feed/NewsFeedComponent";
import {NewsItemType} from "../../../types/NewsItemType";
import {HtmlNewsHeadlineRecord, isHtmlHeadline, isPdfHeadline} from "../../../models/NewsHeadlineRecord";

export const NewsHeadline = "tfNewsHeadline";

export function newsHeadline(): IComponentOptions {
    return {
        template,
        bindings: {
            headline: "<",
            hideSecurity: "<"
        },
        require: {
            newsFeed: "^^tfNewsFeed"
        },
        controllerAs: "ctrl",
        controller: NewsHeadlineComponentController
    };
}

export class NewsHeadlineComponentController {

    /** @input */
    public readonly headline: NewsHeadlineViewModel;

    /** @input */
    public readonly newsFeed: NewsFeedComponentController;

    /** @input */
    public set hideSecurity(hide: boolean) {
        if (hide) {
            this.$element.addClass("hide-security");
        } else {
            this.$element.removeClass("hide-security");
        }
    }

    /** @ngInject */
    public constructor(private readonly $element: IRootElementService) {

    }

    public get hasFile(): boolean {
        return (this.headline != null) && isDocumentModel(this.headline);
    }

    public viewHeadline() {
        if (isDocumentModel(this.headline)) {
            this.newsFeed.markRead(this.headline);
            window.open(this.headline.url, "_blank");
        } else if (isHtmlModel(this.headline)) {
            this.newsFeed.openHeadline(this.headline);
        } else if (isTextModel(this.headline)) {
            this.newsFeed.markRead(this.headline);
        }
    }
}
